/* ===========================================================================
   Step
   =========================================================================== */

import {
    activeClass,
} from '../settings/settings';

export const $stepCounter = $('#js-step-counter');
export const $stepCounterEdit = $('#js-step-counter.edit-view');
export const $stepList = '#js-step-list.edit-view';
export const $buttonStepNext = '.js-step-next';

export function initStepMagellan() {

    let barOffset = '0';

    if (Foundation.MediaQuery.atLeast('large')) {
        barOffset = '90';
    }

    const options = {
        barOffset: barOffset,
        // activeClass: activeClass
    };

    const $counter = new Foundation.Magellan($('#js-step-counter'), options);

}

export function initStepSticky() {

    let stickTo = 'top';
    let marginTop = '4.4';

    if (!Foundation.MediaQuery.atLeast('large'))
        stickTo = 'bottom';

    if (Foundation.MediaQuery.current === 'medium')
        marginTop = '3.7';

    const options = {
        topAnchor: 'js-step-counter-container',
        btmAnchor: 'js-footer',
        marginTop: marginTop,
        marginBottom: '0',
        stickTo: stickTo,
        stickyOn: 'small',
    };

    const $step = new Foundation.Sticky($stepCounter, options);

}

export function invalidInputMessages() {
    const requiredFields = document.getElementById('js-step-list').querySelectorAll('li:not([id="delivery"]) input[required], li:not([id="delivery"]) select[required]');
    const helpMessage = document.getElementById('help-message');
    const priceInput = document.querySelector('.js-vue-price');
    const imagesAlreadyUpdated = document.querySelector('.images-uploaded');

    let invalidInputs = [...requiredFields].some((element) => {
        if (element.type === 'file') {
            return !imagesAlreadyUpdated && element.files.length === 0;
        } else {
            return !element.checkValidity();
        }
    }) || parseFloat(priceInput.value) === 0;
    const btnSubmit = document.getElementById('btnCreate');

    helpMessage.querySelectorAll('span').forEach((messages) => {
        messages.classList.add('is-hidden');
    });

    const containsClass = (targetElement, classText) => {
        return targetElement.classList.contains(classText);
    };

    const manageHidden = (element) => {
        document.getElementById(element).classList.remove('is-hidden');
    };

    if (invalidInputs) {
        if (btnSubmit) btnSubmit.setAttribute('disabled', true);
        helpMessage.classList.remove('is-hidden');
        [...requiredFields].filter((element) => {
            return !element.checkValidity();
        }).forEach((filtered) => {
            const itsName = containsClass(filtered, 'js-vue-name');
            const itsGender = containsClass(filtered, 'js-gender');
            const itsBrand = containsClass(filtered, 'js-brand');
            const itsCondition = containsClass(filtered, 'js-vue-condition');
            const itsFrontPicture = containsClass(filtered, 'front-picture');
            const itsBackPicture = containsClass(filtered, 'back-picture');
            const itsRange = containsClass(filtered, 'js-range');
            const itsColor = containsClass(filtered, 'js-select2-color');
            const itsCategory = containsClass(filtered, 'js-category');
            const itsSize = containsClass(filtered, 'js-size');

            switch (true) {
                case itsName:
                    manageHidden('vue-name-message');
                    break;
                case itsGender:
                    manageHidden('vue-gender-message');
                    break;
                case itsBrand:
                    manageHidden('vue-brand-message');
                    break;
                case itsCondition:
                    manageHidden('vue-condition-message');
                    break;
                case itsFrontPicture:
                    !imagesAlreadyUpdated ? manageHidden('vue-front-picture-message') : '';
                    break;
                case itsBackPicture:
                    !imagesAlreadyUpdated ? manageHidden('vue-back-picture-message') : '';
                    break;
                case itsRange:
                    manageHidden('vue-range-message');
                    break;
                case itsColor:
                    manageHidden('vue-color-message');
                    break;
                case itsCategory:
                    manageHidden('vue-category-message');
                    break;
                case itsSize:
                    manageHidden('vue-size-message');
                    break;
                default:
                    break;
            }
        });
        if (parseFloat(priceInput.value) === 0) {
            manageHidden('vue-price-message');
        }
        if (document.querySelector('.js-select2-color').value === '') {
            manageHidden('vue-color-message');
        }
    } else {
        if (parseFloat(priceInput.value) === 0) {
            document.getElementById('vue-price-message').classList.remove('is-hidden');
        }
        if (document.querySelector('.js-select2-color').value === '') {
            document.getElementById('vue-color-message').classList.remove('is-hidden');
        }
        if (document.querySelector('.js-select2-color').value !== '') {
            document.getElementById('vue-color-message').classList.add('is-hidden');
        }
        if (parseFloat(priceInput.value) !== 0) {
            document.getElementById('vue-price-message').classList.add('is-hidden');
        }
        if (parseFloat(priceInput.value) !== 0 && document.querySelector('.js-select2-color').value !== '') {
            if (btnSubmit) btnSubmit.removeAttribute('disabled');
            helpMessage.classList.add('is-hidden');
        }
    }
}

/**
 * [checkStepValidation description]
 * @return {[type]} [description]
 */
export function checkStepValidation($this) {

    const createProductForm = $('form[name=\'p2s_new_item\']');
    const editProductForm = $('form[name=\'p2s_edit_item\']');
    const isCertifiedItem = (createProductForm.length > 0 && createProductForm.hasClass('new-certified-product-form'))
        || (editProductForm.length > 0 && editProductForm.hasClass('edit-certified-product-form'));
    const btnPublish = $('#btnPublish');
    const hiddenBtnPublish = $('.hidden-publish-btn');

    let $stepActive;

    // Current Step
    if ($($this).hasClass('js-remove-file') || $($this).hasClass('js-file-upload')) {
        $stepActive = $($this.closest('.js-upload-container'));
    } else {
        $stepActive = $($this.closest('.step-item'));
    }
    let inputInvalid = 0;

    // On test manuellement la validation des champs
    $stepActive.find(':input[required]').each(function () {
        const categoryOption = $(this).find('option').not(':first');
        const rangeOption = $('.js-select2-range').find('option').not(':first');

        if ($(this).prop('required')
            && !($(this).hasClass('js-select2-category')
                && rangeOption.length > 0
                && categoryOption.length === 0)) {
            if (($(this).prop('id') === 'p2s_new_iem_gender'
                    && $(this).find(':selected').val() === 'placeholder')
                || $(this).is(':invalid')) {
                inputInvalid++;
            }
        }
    });

    if ($('.js-remuneration').val() !== 'cash'
        && $stepActive.find('input.js-vue-delivery:checkbox').length
        && !$stepActive.find('input.js-vue-delivery:checkbox').is(':checked')) {
        inputInvalid++;
    }

    if ($stepActive.find('input.js-vue-price:input').length
        && true === $stepActive.find('input.js-vue-price:input').val() < 1) {
        inputInvalid++;
    }

    if (!isCertifiedItem && $stepActive.hasClass('js-upload-container')) {
        $stepActive = $stepActive.closest('.step-item');

        if ((!$stepActive.find('input.front-picture').val()
                && $stepActive.find('input.front-picture').data('is-already-uploaded-image') === 'no')
            || (!$stepActive.find('input.back-picture').val()
                && $stepActive.find('input.back-picture').data('is-already-uploaded-image') === 'no')) {
            inputInvalid++;
        }
    }

    // On test la validation des champs de l'étape :
    // S'ils sont valide, alors on peux passer à l'étape suivante (suppression de l'attribut 'disable' sur le bouton)
    // Sinon, on reste sur l'étape en cours
    if (inputInvalid === 0) {
        $stepActive.find($buttonStepNext)
            .attr('disabled', false)
            .addClass('button-animate');
    } else {
        $stepActive.find($buttonStepNext)
            .attr('disabled', true)
            .removeClass('button-animate');

        $stepActive.nextAll().removeClass('is-active');
    }

    if (editProductForm.length && isCertifiedItem && btnPublish.length && hiddenBtnPublish.length) {
        if (isRequiredInformationCompleted(editProductForm, 'edit')) {
            btnPublish.removeClass('is-hidden');
            hiddenBtnPublish.val('true');
        } else {
            btnPublish.addClass('is-hidden');
            hiddenBtnPublish.val('false');
        }
    }

    if (createProductForm.length && isCertifiedItem && btnPublish.length && hiddenBtnPublish.length) {
        if (isRequiredInformationCompleted(createProductForm, 'new')) {
            btnPublish.removeClass('is-hidden');
            hiddenBtnPublish.val('true');
        } else {
            btnPublish.addClass('is-hidden');
            hiddenBtnPublish.val('false');
        }
    }

    // On refresh le module Magellan à cause des nouveaux blocs ouverts/fermés
    $('[data-magellan]').foundation('calcPoints');

    invalidInputMessages();
}

/**
 * [goToNextStep description]
 * @param  {[type]} $this [description]
 * @return {[type]}       [description]
 */
export function goToNextStep($this) {

    // On stock l'id de la prochaine étape
    const nextStepId = $this.closest('li').nextAll('li:not(\'.not-active\')').filter(':first').attr('id');

    // Puis sur l'étape
    $('#js-step-counter').find(`[href="#${nextStepId}"]`).click();

    // Par défault, une étape possède le classe "is-disabled"
    // Cela évite que l'utilisateur navigue sur les étapes désactivées
    // Donc à chaque nouvelle étape, on supprime la classe pour que l'utilisateur puisse naviguer
    setTimeout(() => {
        $('#js-step-counter').find(`.${activeClass}`).removeClass('is-disabled');
    }, 100);

    openNextStep(`#${nextStepId}`);

    // On update le counter des étapes
    counterStepCurrent();
}

/**
 *
 * @param openStepId
 */
export function openNextStep(openStepId) {
    // On refresh le module Magellan à cause des nouveaux blocs ouverts/fermés
    $('[data-magellan]').foundation('calcPoints');

    // Puis on l'affiche
    $(`${openStepId}`).addClass(`${activeClass}`);

}

/**
 * [counterNextStep description]
 * @return {[type]} [description]
 */
function counterStepCurrent() {

    const $counterActive = $('#js-step-counter').find('.is-active');
    const $counterActiveNext = $counterActive.next();

    $counterActiveNext.addClass(activeClass);
    $counterActive.removeClass(activeClass);

}

function isRequiredInformationCompleted(form, formType) {

    if (formType !== 'new' && formType !== 'edit') {
        return false;
    }

    form.find('input[required]').each(function () {
        const categoryOption = $(this).find('option').not(':first');
        const rangeOption = $('.js-select2-range').find('option').not(':first');
        if ($(this).prop('required')
            && !($(this).hasClass('js-select2-category')
                && rangeOption.length > 0
                && categoryOption.length === 0)) {

            if (($(this).prop('id') === 'p2s_new_item_gender'
                    && $(this).find(':selected').val() === 'placeholder')
                || $(this).is(':invalid')) {
                return false;
            }
        }
    });

    if (formType === 'new') {
        const prefixInputName = '#p2s_' + formType + '_';
        const sizeOption = form.find(prefixInputName + 'item_size');
        const colorOption = form.find(prefixInputName + 'item_colors');
        if (sizeOption.val().length === 0
            || colorOption.val() === null) {
            return false;
        }
    }

    //const productDescription = form.find("textarea.js-vue-description");
    const frontPicture = form.find('input.front-picture');
    const backPicture = form.find('input.back-picture');

    if (formType === 'edit') {
        const imagesAlreadyUpdated = $('.images-uploaded');

        if (imagesAlreadyUpdated) {
            return ![...form[0].querySelectorAll('[required]:not([type=file])')].some((element) => {
                return !element.checkValidity();
            });
        } else {
            return ![...form[0].querySelectorAll('[required]')].some((element) => {
                return !element.checkValidity();
            });
        }
    }

    if (//!$.trim(productDescription.val()).length ||
        (!frontPicture.val() && frontPicture.data('is-already-uploaded-image') === 'no')
        || (!backPicture.val() && backPicture.data('is-already-uploaded-image') === 'no')) {
        return false;
    }

    return true;
}
